import { Button } from '@synergy-marine-group/synergy-ui';
import React from 'react';
import Modal from 'react-responsive-modal';
import { createModalStyles } from './styles';

const DuplicateSave = ({ modal, setModal, handleSave, isPPE, handleDraft,
    openDuplicate, duplicateData, handleDiscard, setisduplicateloading, poId }) => {
  return (
    <div className="custom-modal">
      <Modal
        classNames={{
          overlay: 'trasparent'
        }}
        open={modal}
        onClose={() => {
          setModal(false);
          setisduplicateloading(false);
        }}
        closeOnOverlayClick={false}
        center
        showCloseIcon={false}
        styles={createModalStyles}
      >
        <div className="align-left font-muli">
          <div className="uppercase pb-4 text-left text-lg font-montserrat font-semibold">Duplicate Entry found!</div>
          <div className="font-muli bg-amber-50">
            <ul className="font-muli text-left p-4 ">
              {duplicateData.map((dupdata) => (
                <ol className="cursor-pointer text-base p-2 underline" key={dupdata.poId} onClick={() => openDuplicate(dupdata.poId)}>
                  {dupdata.poNumber}
                </ol>
              ))}
            </ul>
          </div>
          <div className="font-muli text-sm pb-6">
            {isPPE ? (
            <p className="font-muli text-base p-2">Due to an existing open PO, the current action cannot be completed. Please save your changes as a draft for future reference.</p>
            ) : (
              <p className="font-muli text-base p-2">Do you want to proceed with creation of this PO ?</p>
              )}
          </div>

          <div className="flex justify-end">
            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={handleDiscard}
              size="large"
              variant="outlined"
              rounded
            >
              Discard
            </Button>
            <div>
              <Button
                className="ml-4 max-w-none font-montserrat text-gray-500 uppercase text-sm"
                onClick={isPPE ? handleDraft : handleSave}
                size="large"
                variant=" filled"
                rounded
              >
                {isPPE ? poId ? 'Save' : 'Save as Draft' : 'Continue'}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DuplicateSave;
